<script>
import baseMixin from '@/mixins/baseMixin'
import TheSettingsProfileCard from './the-settings-profile-card.vue'

export default {
  name: 'TheSettingsContainer',
  components: { TheSettingsProfileCard },
  mixins: [baseMixin],
  props: {},
  data: () => {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<template>
  <section>
    <TheSettingsProfileCard />
  </section>
</template>
